import { MONTANT_MAX, MONTANT_MIN, MONTANT_NEGATIVE_MIN } from '@lib/utils/app-utils';
import { getLastYearDate } from '@lib/validators/min-signature-date.validator';
import { OuiValidationError } from 'omnium-ui/form-field';

export const requiredError: OuiValidationError = {
  code: 'required',
  message: 'Ce champ est requis',
};

const dateParseError: OuiValidationError = {
  code: 'matDatepickerParse',
  message: 'Format de date invalide. Saisir la date au format JJ/MM/AAAA',
};

const pastDateError: OuiValidationError = {
  code: 'pastDate',
  message: "La date saisie ne peut pas être postérieure à aujourd'hui",
};

const futureDateError: OuiValidationError = {
  code: 'futureDate',
  message: "La date saisie doit être ultérieure à aujourd'hui",
};

const minTodayDateError: OuiValidationError = {
  code: 'matDatepickerMin',
  message: "La date saisie ne peut pas être antérieure à aujourd'hui",
};

const minDateError: OuiValidationError = {
  code: 'minDate',
  message: 'Ce champ doit contenir une date postérieure au 01/01/1901',
};

const minSignatureDateError: OuiValidationError = {
  code: 'minSignatureDate',
  message: 'Ce champ doit contenir une date postérieure au ' + getLastYearDate().toLocaleDateString('fr-FR'),
};

const minMaxMontantError: OuiValidationError = {
  code: 'montantError',
  message: `La valeur doit être comprise entre ${MONTANT_MIN} et ${MONTANT_MAX}`,
};

const minMaxNegativeMontantError: OuiValidationError = {
  code: 'montantError',
  message: `La valeur doit être comprise entre ${MONTANT_NEGATIVE_MIN} et ${MONTANT_MAX}`,
};

const dureePretError: OuiValidationError = {
  code: 'dureePretError',
  message: `La valeur doit être comprise entre 0 et 999 mois`,
};
const percentError: OuiValidationError = {
  code: 'percent',
  message: `La valeur doit être comprise entre 0 et 100`,
};

const rangeDateError: OuiValidationError = {
  code: 'rangeDate',
  message: `La date de fin doit être supérieure ou égale à la date de début`,
};
const emailError: OuiValidationError = { code: 'email', message: "L'adresse e-mail n'est pas valide" };

const frenchTelephoneError: OuiValidationError = { code: 'frenchPhoneInvalid', message: "Le numéro de téléphone n'est pas valide" };

const minMontantError: OuiValidationError = { code: 'minMontant', message: 'Le nombre doit être supérieur ou égal à la valeur minimum' };
const fourDigitError: OuiValidationError = { code: 'fourDigit', message: 'Entrée une année au format 0000 (2025)' };
const posterieureError: OuiValidationError = {
  code: 'posterieure',
  message: "L'année saisie ne peut pas être postérieure à l’année en cours.",
};

const differentConsultantEmailError: OuiValidationError = {
  code: 'sameAsConsultantEmail',
  message: "L'adresse email de l'investisseur ne peut pas être identique à votre adresse email en tant que consultant.",
};
const differentConsultantPhoneError: OuiValidationError = {
  code: 'sameAsConsultantPhone',
  message: "Le numéro de mobile de l'investisseur ne peut pas être identique à votre numéro en tant que consultant.",
};
const epargneSecuriseeDisponibleError: OuiValidationError = {
  code: 'montantDisponible',
  message: "Le montant de l'épargne sécurisée disponible ne peut être supérieur à l'épargne disponible.",
};
const epargneSecuriseeValeurError: OuiValidationError = {
  code: 'valeurEstimee',
  message: "Le montant de l'épargne sécurisée ne peut être supérieur à la valeur estimée.",
};
const montantDisponibleError: OuiValidationError = {
  code: 'montantDisponible',
  message: 'Le montant disponible ne peut pas être supérieur à la valeur estimée.',
};

export function maxLengthError(max: number): OuiValidationError {
  return {
    code: 'maxlength',
    message: `Maximum  ${max} caractères, espace compris`,
  };
}
export function maxLengthNameError(max: number): OuiValidationError {
  return {
    code: 'maxlength',
    message: `Le nom est trop long : ${max} caractères maximum, espaces compris`,
  };
}
export const requiredBirthDateErrors = [requiredError, pastDateError, minDateError, dateParseError];
export const requiredMontantErrors = [requiredError, minMaxMontantError];
export const requiredNegativeMontantErrors = [requiredError, minMaxNegativeMontantError];
export const identiteDocumentErrors = [requiredError, futureDateError, dateParseError];
export const minMaxMontantErrors = [minMaxMontantError];
export const percentErrors = [percentError];
export const fourDigitErrors = [fourDigitError];
export const requiredRangeDateErrors = [requiredError, rangeDateError];
export const requiredDateErrors = [requiredError, minDateError, pastDateError, dateParseError, futureDateError];
export const requiredPhoneErrors = [requiredError, frenchTelephoneError, differentConsultantPhoneError];
export const requiredEmailErrors = [requiredError, emailError, differentConsultantEmailError];
export const minMontantErrors = [requiredError, minMaxMontantError, minMontantError];
export const dureePretErrors = [requiredError, dureePretError];
export const posterieureErrors = [requiredError, posterieureError];
export const epargneSecuriseeErrors = [epargneSecuriseeDisponibleError, epargneSecuriseeValeurError];
export const montantDisponibleErrors = [montantDisponibleError];
export const requiredSignatureDateErrors = [requiredError, minDateError, minSignatureDateError, dateParseError];
export const requiredUpcomingDateErrors = [requiredError, minTodayDateError, dateParseError];
